
import { computed, defineComponent } from 'vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import { useStore } from 'vue2-helpers/vuex';
import useResponsiveness from '@/mixins/useResponsiveness';
import { useRouter } from 'vue2-helpers/vue-router';
import { onMounted } from 'vue-demi';
import useUser from '@/mixins/useUser';
import { useSessionStorage } from '@vueuse/core';

export default defineComponent({
  name: 'RegistrationFinished',
  components: { BCXMarkdown },
  setup() {
    const store = useStore();
    const router = useRouter();
    const { isMobileWidth } = useResponsiveness();

    const { tUser } = useUser('self');
    const registrationEmail = useSessionStorage('registrationEmail', '');

    const gotoLogin = () => {
      const email = registrationEmail.value;
      registrationEmail.value = '';
      store.commit('clearUserAndToken');
      router.push({ name: 'login', query: email ? { email } : undefined });
    };

    onMounted(() => {
      setTimeout(gotoLogin, 5000);
    });

    const welcomeText = computed(() => tUser('registration_USERTYPE.welcome_title'));
    const welcomeTextSub = computed(() => tUser('registration_USERTYPE.welcome_subtitle'));

    return {
      isMobileWidth,
      gotoLogin,
      welcomeText,
      welcomeTextSub
    };
  },
});
